var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSoup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.861,24H10.139a8.922,8.922,0,0,1-6.268-2.534A14.759,14.759,0,0,1,.164,15.15,4.011,4.011,0,0,1,4,10H20a4.012,4.012,0,0,1,3.838,5.15,14.741,14.741,0,0,1-3.708,6.316A8.918,8.918,0,0,1,13.861,24ZM4,12a1.981,1.981,0,0,0-1.6.8,2.019,2.019,0,0,0-.322,1.791,12.933,12.933,0,0,0,3.2,5.46A6.907,6.907,0,0,0,10.139,22h3.722a6.9,6.9,0,0,0,4.856-1.951,12.919,12.919,0,0,0,3.2-5.46,2.019,2.019,0,0,0-.322-1.791A1.978,1.978,0,0,0,20,12ZM16,6a4.381,4.381,0,0,0-1.293-3.121A2.4,2.4,0,0,1,14,1.168V1A1,1,0,1,0,12,1v.168a4.385,4.385,0,0,0,1.293,3.122A2.4,2.4,0,0,1,14,6a1,1,0,0,0,2,0ZM12,7V6.692a4.387,4.387,0,0,0-1.292-3.121A2.4,2.4,0,0,1,10,1.864V1A1,1,0,0,0,8,1v.864A4.386,4.386,0,0,0,9.293,4.985,2.4,2.4,0,0,1,10,6.692V7a1,1,0,0,0,2,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoup);
export default __webpack_public_path__ + "static/media/soup.d8d0a272f5f5fb7e9a40c366590d0b5f.svg";
export { ForwardRef as ReactComponent };